import { UIView } from "uikit";

export interface StepViewProtocol
{
    stepView: StepView;
}

export class StepView extends UIView
{
    set selected ( value: boolean ) {
        if ( value == true ) {
            this.layer.addStyle( "selected" );
        }
        else {
            this.layer.removeStyle( "selected" );
        }
    }
}